export const INSTALATION_ADDRESS_TITLE = 'Installation address';
export const INSTALATION_ADDRESS_TITLE_ALT = 'Installation address & contact details';
export const ADDRESS_LABEL = 'Installation address: ';
export const EMAIL_ADDRESS_LABEL = 'Email address: ';
export const SITE_CONTACT_LABEL = 'Site contact: ';
export const UPDATE_DETAILS_BUTTON_LABEL = 'Update Details';
export const ANALYTICS_NO_APPOINTMENT_TODAY = 'none';
export const ANALYTICS_AMEND_APPT_YES = 'yes';
export const ANALYTICS_AMEND_APPT_NO = 'no';
